import { createAction, props } from '@ngrx/store';
import {LocationSet} from '@emm/core/models/location-set.model';

export enum LocationSetsAction {
    LoadByTag = '[Location Sets Management] Load Location Sets By Tag',
    LoadByTagSuccess = '[Management API] Load Location Sets By Tag Success',
    LoadByTagFailure = '[Management API] Load Location Sets By Tag Failure',
    LoadAllByScope = '[Management Location Sets Effects] Load All Location Sets By Scope',
    LoadAllByScopeSuccess = '[Menu API] Load All Location Sets By Scope Success',
    LoadAllByScopeFailure = '[Menu API] Load All Location Sets By Scope Failure',
    Select = '[Location Sets Management] Select Location Set',
    LoadLocationsByParent = '[Location Sets Management] Load Locations By Parent',
    LoadLocationsByParentSuccess = '[Management API] Load Locations By Parent Success',
    LoadLocationsByParentFailure = '[Management API] Load Locations By Parent Failure',
    LoadChildLocations = '[Location Sets Management] Load Child Locations',
    LoadChildLocationsSuccess = '[Management API] Load Child Locations Success',
    LoadChildLocationsFailure = '[Management API] Load Child Locations Failure',
    AddChildLocations = '[Location Sets Management] Add Child Locations',
    AddChildLocationsSuccess = '[Management API] Add Child Locations Success',
    AddChildLocationsFailure = '[Management API] Add Child Locations Failure',
    DeleteLocationSet = '[Location Sets Management] Delete Location Set',
    DeleteLocationSetSuccess = '[Management API] Delete Location Set Success',
    DeleteLocationSetFailure = '[Management API] Delete Location Set Failure',
    RemoveChildLocation = '[Location Sets Management] Remove Child Location',
    RemoveChildLocationSuccess = '[Management API] Remove Child Location Success',
    RemoveChildLocationFailure = '[Management API] Remove Child Location Failure',
    UpdateFilter = '[Location Set Picker] Update Filter',
    OpenAddDialog = '[Location Sets Management] Open Add Location Dialog'
}

export const LocationSetsActions = {
    loadByTag: createAction(LocationSetsAction.LoadByTag),
    loadByTagSuccess: createAction(
        LocationSetsAction.LoadByTagSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),
    loadByTagFailure: createAction(LocationSetsAction.LoadByTagFailure, props<{ error: any }>()),
    loadAllByScope: createAction(LocationSetsAction.LoadAllByScope),
    loadAllByScopeSuccess: createAction(
        LocationSetsAction.LoadAllByScopeSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),
    loadAllByScopeFailure: createAction(LocationSetsAction.LoadAllByScopeFailure, props<{ error: any, showError: boolean }>()),
    select: createAction(LocationSetsAction.Select, props<{ tag: string, locationSet: LocationSet }>()),
    loadLocationsByParent: createAction(LocationSetsAction.LoadLocationsByParent, props<{ id: string }>()),
    loadLocationsByParentSuccess: createAction(
        LocationSetsAction.LoadLocationsByParentSuccess,
        props<{ locations: LocationSet[] }>()
    ),
    loadLocationsByParentFailure: createAction(
        LocationSetsAction.LoadLocationsByParentFailure,
        props<{ error: any }>()
    ),
    loadChildLocations: createAction(LocationSetsAction.LoadChildLocations, props<{ tag: string }>()),
    loadChildLocationsSuccess: createAction(
        LocationSetsAction.LoadChildLocationsSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),
    loadChildLocationsFailure: createAction(
        LocationSetsAction.LoadChildLocationsFailure,
        props<{ error: any }>()
    ),
    addChildLocations: createAction(
        LocationSetsAction.AddChildLocations,
        props<{ parentTag: string; childTags: any }>()
    ),
    addChildLocationsSuccess: createAction(LocationSetsAction.AddChildLocationsSuccess),
    addChildLocationsFailure: createAction(LocationSetsAction.AddChildLocationsFailure, props<{ error: any }>()),
    deleteLocationSet: createAction(LocationSetsAction.DeleteLocationSet, props<{ tag: string }>()),
    deleteLocationSetSuccess: createAction(LocationSetsAction.DeleteLocationSetSuccess),
    deleteLocationSetFailure: createAction(LocationSetsAction.DeleteLocationSetFailure, props<{ error: any }>()),
    removeChildLocation: createAction(
        LocationSetsAction.RemoveChildLocation,
        props<{ parentTag: string; childTag: string }>()
    ),
    removeChildLocationSuccess: createAction(LocationSetsAction.RemoveChildLocationSuccess),
    removeChildLocationFailure: createAction(
        LocationSetsAction.RemoveChildLocationFailure,
        props<{ error: any }>()
    ),
    updateFilter: createAction(LocationSetsAction.UpdateFilter, props<{ filter: string }>()),
    openAddDialog: createAction(LocationSetsAction.OpenAddDialog)
};

export const AsyncActions = {
    loadActions: [
        LocationSetsActions.loadByTag,
        LocationSetsActions.loadAllByScope,
        LocationSetsActions.loadLocationsByParent,
        LocationSetsActions.addChildLocations,
        LocationSetsActions.deleteLocationSet,
        LocationSetsActions.removeChildLocation
    ],
    successActions: [
        LocationSetsActions.loadByTagSuccess,
        LocationSetsActions.loadAllByScopeSuccess,
        LocationSetsActions.loadLocationsByParentSuccess,
        LocationSetsActions.addChildLocationsSuccess,
        LocationSetsActions.deleteLocationSetSuccess,
        LocationSetsActions.removeChildLocationSuccess
    ],
    errorActions: [
        LocationSetsActions.loadByTagFailure,
        LocationSetsActions.loadAllByScopeFailure,
        LocationSetsActions.loadLocationsByParentFailure,
        LocationSetsActions.addChildLocationsFailure,
        LocationSetsActions.deleteLocationSetFailure,
        LocationSetsActions.removeChildLocationFailure
    ]
};
